import { IconProps } from '@models/icons';

function ToastInfo({ size = 24, color = '#2B84E3', ...rest }:IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <circle cx="12.5" cy="12" r="6" fill={color}/>
            <path d="M11.775 9.70332V9.69766C11.775 9.29725 12.0996 8.97266 12.5 8.97266C12.9004 8.97266 13.225 9.29725 13.225 9.69766V9.70332C13.225 10.1037 12.9004 10.4283 12.5 10.4283C12.0996 10.4283 11.775 10.1037 11.775 9.70332Z"
                  fill="white"/>
            <path d="M12.5 12.0283V15.0283" stroke="white" strokeLinecap="round"/>
        </svg>
  );
}

export default ToastInfo;
